var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v(_vm._s(_vm.label))]),_c('status-component',{attrs:{"level":_vm.value.level,"display":_vm.value.display}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }